<template>
    <b-navbar toggleable="lg" type="dark" variant="info">
        <b-navbar-brand :to="{ name: 'home' }">Cost Explorer</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
                <b-nav-item
                    :to="{ name: 'payers' }"
                    :active="$route.name === 'payers'"
                    >Payers</b-nav-item
                >
                <b-nav-item
                    :active="$route.name == 'dealer'"
                    v-if="$store.getters.user.username"
                    :to="{ name: 'dealer' }"
                    >Dealer</b-nav-item
                >
            </b-navbar-nav>

            <b-navbar-nav class="ml-auto">
                <b-nav-item-dropdown v-if="$store.getters.user.username" right>
                    <!-- Using 'button-content' slot -->
                    <template #button-content>
                        <span class="text-white">
                            Hi <b>{{ $store.getters.user.username || '' }}</b>
                        </span>
                    </template>
                    <b-dropdown-item @click="logout"> Logout </b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item v-else @click="login">Login</b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Header',
    mounted() {
        if (!this.$store.getters.user.username) {
            location.replace(this.$auth.getLoginURL());
        }
    },
    methods: {
        login: function () {
            location.replace(this.$auth.getLoginURL());
        },
        logout: function () {
            this.$auth.logout();
        },
    },
};
</script>

<style scoped></style>
